// Client-side PDF text extraction (pdf.js). The PDF is an IMPORT SOURCE only and
// never leaves the browser; extracted text is fed to the shared reference detector.
import * as pdfjsLib from "pdfjs-dist/build/pdf";

// Worker script (JS only, no user data) loaded from CDN, pinned to the installed version.
pdfjsLib.GlobalWorkerOptions.workerSrc = `https://cdnjs.cloudflare.com/ajax/libs/pdf.js/${pdfjsLib.version}/pdf.worker.min.js`;

// Extract text from a PDF array buffer, reconstructing lines from text-item positions.
export async function extractPdfText(arrayBuffer) {
  const pdf = await pdfjsLib.getDocument({ data: arrayBuffer, isEvalSupported: false }).promise;
  const pages = [];
  for (let n = 1; n <= pdf.numPages; n++) {
    const page = await pdf.getPage(n);
    const content = await page.getTextContent();
    const lines = [];
    let line = "";
    let lastY = null;
    for (const item of content.items) {
      const y = item.transform ? item.transform[5] : null;
      if (lastY !== null && y !== null && Math.abs(y - lastY) > 2.5) {
        if (line.trim()) lines.push(line.trim());
        line = "";
      }
      line += item.str;
      if (item.hasEOL) {
        if (line.trim()) lines.push(line.trim());
        line = "";
        lastY = null;
      } else {
        lastY = y;
      }
    }
    if (line.trim()) lines.push(line.trim());
    pages.push(lines.join("\n"));
  }
  return pages.join("\n\n");
}
